import {
  ApplicationConfig,
  provideZoneChangeDetection,
  isDevMode, importProvidersFrom,
} from '@angular/core';
import { routes } from './app.routes';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RedirectInterceptor } from './interceptors/redirect.interceptor';
import { withCredentialsInterceptor } from './interceptors/withCredentails.interceptor';
import { authInterceptor } from './interceptors/http.interceptor';
import { progressLoaderInterceptor } from './interceptors/progress-loader.interceptor';
import { en_GB, provideNzI18n } from "ng-zorro-antd/i18n";
import { registerLocaleData } from '@angular/common';
import en_IN from '@angular/common/locales/en-IN';
import { FormsModule } from '@angular/forms';
import { NzNotificationModule } from 'ng-zorro-antd/notification';

registerLocaleData(en_IN);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({
      eventCoalescing: true,
      runCoalescing: true
    }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideStore(),
    provideEffects(),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false
    }),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        withCredentialsInterceptor,
        // RedirectInterceptor, //TODO: Start using this interceptor to honour backend redirections
        progressLoaderInterceptor,
      ])
    ),
    provideNzI18n(en_GB),
    importProvidersFrom(FormsModule, NzNotificationModule)
  ],
};


